import { Tag, Tooltip } from 'antd'
import BigNumber from 'bignumber.js'
import React from 'react'
import { COLORS } from '../../../constants'
import Contracts from '../../PositionColumns/Contracts'
import { TagWrap } from './styles'
import EntryTime from '../../PositionColumns/EntryTime'
import Price from '../../PositionColumns/Price'
import { CheckOutlined, StopOutlined } from '@ant-design/icons'
import Contracts2 from '../../PositionColumns/Contracts2'
import PnlPrice from '../../PositionColumns/PnlPrice'
import { Text } from '../../../../styles/reactnative'

export const column_order = (mutate, showModal, token, fold) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			sorter: (a, b) => a.id - b.id,
			width: 70,
			render: (text, record) => <Tooltip title={record?.uuid}>{text}</Tooltip>,
		},
		{
			title: '원번호',
			dataIndex: 'original_id',
			key: 'original_id',
			align: 'center',
			width: 70,
			render: (text, record) => <Text>{text}</Text>,
		},
		{
			title: '주문일',
			align: 'center',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 65,
			render: (text, record) => (
				<div style={{ 
					textAlign: 'center',
					lineHeight: 1.2
				}}>
					<EntryTime
						time={record.created_at}
						format="YY-MM-DD"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
					<EntryTime
						time={record.created_at}
						format="HH:mm:ss"
						style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
					/>
				</div>
			),
		},
		{
			title: '체결일',
			align: 'center',
			dataIndex: 'traded_at',
			key: 'traded_at',
			width: 65,
			render: (text, record) => (
				<div style={{ 
					textAlign: 'center',
					lineHeight: 1.2
				}}>
					{record.traded_at ? (
						<>
							<EntryTime
								time={record.traded_at}
								format="YY-MM-DD"
								style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
							/>
							<EntryTime
								time={record.traded_at}
								format="HH:mm:ss"
								style={{ display: 'block', fontSize: 12, fontWeight: 'normal', color: '#333' }}
							/>
						</>
					) : (
						<span style={{ color: '#ccc', fontSize: 12 }}>-</span>
					)}
				</div>
			),
		},
		{
			title: '종목',
			dataIndex: 'pairs',
			key: 'pairs',
			align: 'center',
			width: 120,
			render: (text, record) => <Contracts2 data={record} />,
		},
		{
			title: '구분',
			dataIndex: 'type',
			key: 'type',
			align: 'center',
			width: 50,
			render: (text, record) => (
				<span
					style={{
						color:
							record?.long_short === 'L'
								? COLORS.lightGreen
								: COLORS.lightRed,
						fontSize: '12px',
						fontWeight: '500'
					}}>
					{record?.long_short === 'L' ? '매수' : '매도'}
				</span>
			),
		},
		{
			title: '상태',
			dataIndex: 'status',
			key: 'status',
			align: 'center',
			width: 80,
			render: (text, record) => (
				<TagWrap style={{ justifyContent: 'center' }}>
					<Tag
						style={{
							alignItems: 'center',
							justifyContent: 'center',
							display: 'flex',
							color:
								text == 2
									? record?.open_close == 'O'
										? COLORS.lightGreen
										: COLORS.darkBlue
									: text == 1
									? COLORS.lightBlue
									: COLORS.lightRed,
						}}>
						{text == 2 ? (
							<CheckOutlined size={5} />
						) : text != 1 ? (
							<StopOutlined size={5} />
						) : null}
						{text == 1
							? '대기'
							: text == 2
							? `${
									record?.open_close == 'O' ? '신규' : '종료'
							  }체결`
							: '취소'}
					</Tag>
				</TagWrap>
			),
		},
		{
			title: '마진',
			dataIndex: 'margin',
			align: 'right',
			key: 'margin',
			render: (text, record) => (
				<div
					style={{
						fontSize: 12,
						whiteSpace: 'nowrap',
					}}>
					<span style={{ textAlign:'right' }}>
						{BigNumber(record?.margin).toFormat(0)}
					</span>
				</div>
			),
		},
		{
			title: '주문가',
			dataIndex: 'order_price',
			align: 'center',
			key: 'order_price',
			render: (text, record) => (
				<Price
					price={record?.order_price || 0}
					ep_id={record?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '체결가',
			dataIndex: 'trade_price',
			align: 'center',
			key: 'trade_price',
			render: (text, record) => (
				<Price
					price={record?.trade_price || 0}
					ep_id={record?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '체결수량',
			dataIndex: 'amount',
			align: 'center',
			key: 'amount',
			render: (text, record) => (
				<div
					style={{
						fontSize: 12,
						whiteSpace: 'nowrap',
					}}>
					<span style={{ fontWeight: 'bold' }}>
						{BigNumber(record?.amount)
							.minus(record?.remain_amount)
							.toFormat(0)}
					</span>
					{' '}/ <span>{BigNumber(record?.amount).toFormat(0)}</span>
				</div>
			),
		},
		{
			title: '매매손익',
			align: 'center',
			dataIndex: 'pnl_price',
			key: 'pnl_price',
			width: 100,
			render: (text, record) => (
				<>
					<PnlPrice
						price={text}
						ep_id={record?.exchange_pairs_id}
						dp={0}
						krw={true}
					/>
				</>
			),
		},
		{
			title: '수수료',
			align: 'center',
			dataIndex: 'fee_price',
			key: 'fee_price',
			width: 90,
			render: (text, record) => (
				<PnlPrice
					price={-text}
					ep_id={record?.exchange_pairs_id}
					dp={0}
					krw={true}
				/>
			),
		},
		{
			title: '비고',
			align: 'center',
			key: 'remarks',
			width: 160,
			render: (text, record) => <Contracts data={record} />,
		},
	]
}
